import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

import { SpinCentered } from '@/comp';
import EPTierTooltip, { EPTierTooltipProps } from '@/comp/common/EPTierTooltip';

interface HighchartsContainerProps {
  options: Highcharts.Options;
  isReady: boolean;
  withTooltip?: boolean;
  tooltipProps?: EPTierTooltipProps;
  children?: React.ReactNode;
}

const HighchartsContainer = ({
  options,
  isReady,
  withTooltip = false,
  tooltipProps,
  children = null,
}: HighchartsContainerProps) => (
  <div className="highcharts-container">
    <div className={'relative'}>
      {!isReady || !options ? (
        <SpinCentered className={'spinner'} />
      ) : (
        <>
          {withTooltip ? (
            <EPTierTooltip {...tooltipProps}>
              <div>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={options}
                  containerProps={{ className: 'highcharts-chart-data' }}
                />
              </div>
            </EPTierTooltip>
          ) : (
            <div>
              <HighchartsReact
                highcharts={Highcharts}
                options={options}
                containerProps={{ className: 'highcharts-chart-data' }}
              />
            </div>
          )}
        </>
      )}
    </div>
    {isReady && options && children}
  </div>
);

export default HighchartsContainer;
